import { createSlice } from '@reduxjs/toolkit'

export const ProjectStatusSlice = createSlice(
  {
  name: 'project_status',
  initialState: {
    value: '',
  },
  reducers: {
    projectStatusSelected: (state, action) => {
      state.value = action.payload
    },
  },
})
export const { projectStatusSelected } = ProjectStatusSlice.actions

export default ProjectStatusSlice.reducer